var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('iframe',{ref:"child",staticClass:"third",attrs:{"src":_vm.isDev
        ? 'http://127.0.0.1:8000/#/?token=' + _vm.token
        : _vm.verConfig.chatUrl + '/#/?token=' + _vm.token,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }